import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { useAuth } from 'contexts';
import { Role } from 'types';

const Redirecting = () => {
  const navigate = useNavigate();

  const { userProfile } = useAuth();

  useEffect(() => {
    switch (userProfile.role) {
      case Role.ADMIN:
      case Role.BILLING_ADMIN:
      case Role.SENIOR_BOOKING:
      case Role.BOOKING:
      case Role.CARRIER:
      case Role.ADMIN_CUSTOMER:
      case Role.CUSTOMER:
      case Role.EXTERNAL:
        navigate('/dashboard');
        break;
      case Role.GATE:
      case Role.GATE_BOOKING:
        navigate('/gate');
        break;
      case Role.NONE: /* awaiting preferences */
      default:
        break;
    }
    return;
  }, [userProfile.role, navigate]);

  return <div>Redirecting...</div>;
};

export default Redirecting;
